import * as angular from "angular"
import { createRange, getSelectedYearsLabel } from "../../omnia"
import { CropVM } from "./crop"
import { IntervalVm } from "./interval"

/// <reference path="interval.ts" />

import ICropYieldScale = omnia.models.ICropYieldScale

export class CropScalesVM {

    public scale: ICropYieldScale;
    public isNew: boolean;
    public removed: boolean;

    public intervals: IntervalVm[]

    private _yearsText: string
    private _original: string

    constructor(public crop: CropVM, private originalScale: ICropYieldScale) {

        this._original = this.getScaleState(originalScale)

        this.scale = angular.extend({}, this.originalScale)
        this.scale.MapStyle = this.originalScale.MapStyle.slice()
        this.scale.Years = this.originalScale.Years.slice()

        this._yearsText = getSelectedYearsLabel(this.scale.Years, null)

        this.updateIntervals()

    }

    get edited(): boolean {
        return this.isNew || this.hasChanged();
    }

    private hasChanged() {
        const state = this.getScaleState(this.scale)
        return (state != this._original)
    }

    public isValid(): boolean {
        return this.scale.MinYield
            && this.scale.MaxYield
            && (this.scale.MinYield < this.scale.MaxYield)
            && (this.scale.Intervals > 2)
            && (this.mapStyle.length === this.scale.Intervals)
    }

    get years() {
        return this.scale.Years
    }

    set years(years) {
        this.scale.Years = years
        this._yearsText = getSelectedYearsLabel(years, null)
    }

    get yearsText() {
        return this._yearsText
    }

    get intervalCount() {
        return this.scale.Intervals
    }

    get mapStyle() {
        return this.scale.MapStyle
    }

    get maxYield() {
        return this.scale.MaxYield
    }

    addInterval() {
        this.scale.Intervals++;

        var color = this.mapStyle.length ? [70, 168, 96] : [246, 56, 59];

        if (this.mapStyle.length > 1) {
            var colorA = this.scale.MapStyle[this.mapStyle.length - 2];
            var colorB = this.scale.MapStyle[this.mapStyle.length - 1];
            color = omnia.color.createLinearGradient([colorA, colorB], 3)[1];
        }

        if (this.mapStyle.length > 1) {
            this.mapStyle.splice(this.mapStyle.length - 1, 0, color);
        } else {
            this.mapStyle.push(color);
        }

        this.updateIntervals()

    }

    removeInterval(index: number) {
        this.scale.Intervals--
        this.mapStyle.remove(s => this.mapStyle.indexOf(s) === index)
        this.updateIntervals()
    }

    reverse() {
        this.scale.MapStyle = this.mapStyle.reverse();
        this.updateIntervals()

    }

    getYield(index): number {

        if (!(this.scale.MinYield >= 0 && this.scale.MaxYield >= 0)) {
            return null;
        }

        if (this.scale.Intervals < 3) {
            return null
        }

        switch (index) {

            case 0:
            case 1:
                return this.scale.MinYield

            case (this.scale.Intervals - 1):
                return this.scale.MaxYield

            case this.scale.Intervals:
                return null;

            default:
                const step = (this.scale.MaxYield - this.scale.MinYield) / (this.scale.Intervals - 2)
                return this.scale.MinYield + Math.round((step * (index - 1)) * 10) / 10

        }

    }

    private updateIntervals() {

        const n = this.intervalCount

        const intervals = createRange(0, n, index => <IntervalVm>{
            yield: this.getYield(index),
            min: index == 0,
            max: index == (n - 1),
            small: n > 7,
            widthPct: (100 / n)
        })

        this.intervals = intervals

    }

    private getScaleState(scale: ICropYieldScale) {

        return JSON.stringify({
            MinYield: scale.MinYield,
            MaxYield: scale.MaxYield,
            Intervals: scale.Intervals,
            MapStyle: scale.MapStyle,
            Years: scale.Years
        })

    }
}
